import { render, staticRenderFns } from "./warningInfo.vue?vue&type=template&id=6b869f48&scoped=true&"
import script from "./warningInfo.vue?vue&type=script&lang=js&"
export * from "./warningInfo.vue?vue&type=script&lang=js&"
import style0 from "./warningInfo.vue?vue&type=style&index=0&id=6b869f48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b869f48",
  null
  
)

export default component.exports